import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getClickToToggleContextualSidebar } from '../constants/events';
import { InfoIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const RightSidebarToggle = ({
  toggleSidebar
}) => {
  const toggleRightSidebar = () => {
    toggleSidebar();
    trackEvent(getClickToToggleContextualSidebar());
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.buttons.ContextualSidebarToggle.tooltip"
    }),
    placement: "bottom",
    children: /*#__PURE__*/_jsx(IconButton, {
      onClick: toggleRightSidebar,
      "data-test-id": "contact-sidebar-toggle",
      children: /*#__PURE__*/_jsx(InfoIcon, {
        size: "400"
      })
    })
  });
};
RightSidebarToggle.displayName = 'RightSidebarToggle';
export default RightSidebarToggle;